module.exports = __webpack_public_path__ + "static/media/Sec-1-Background.16e194f0.webp";